import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../../context/AuthContext";

import {yupResolver} from "@hookform/resolvers/yup";
import {useForm} from "react-hook-form";
import * as yup from "yup";

import {toast} from "react-toastify";
import styles from "./ForgotPasswordPage.module.css";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

const ForgotPasswordPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {forgotPassword, loading} = useAuth();

    const [error, setError] = useState("");

    const schema = useMemo(
        () =>
            yup.object().shape({
                email: yup
                    .string()
                    .email(t("validation.emailFormat"))
                    .required(t("validation.emailRequired")),
            }),
        [t]
    );

    const {
        register,
        handleSubmit,
        formState: {errors, isSubmitting},
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onBlur",
    });

    const onSubmit = async (values) => {
        try {
            setError("");
            const data = await forgotPassword(values);
            const token = data?.data?.verificationToken;
            // Persist so a page reload during the OTP / resend / set-new-password
            // steps doesn't lose the token (location.state is in-memory only).
            if (token) {
                sessionStorage.setItem("gredus.forgotPasswordToken", token);
            }
            navigate("/forgot-password/confirm", {
                state: {verificationToken: token}
            });
            toast.success(t("toasts.passwordResetSent"), {
                toastId: "forgot-password-success",
            });
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err.message ||
                t("auth.forgotPasswordSendError");
            setError(msg);
        }
    };

    return (
        <div className={styles.wrapper}>
            <Link to="/">
                <img src="/gredus-logo.svg" alt="logo" className={styles.logo}/>
            </Link>

            <div className={styles.card}>
                <h2 className={styles.title}>{t("auth.forgotPasswordCardTitle")}</h2>

                <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                    {error && <p className={styles.error}>{error}</p>}

                    <div className={styles.formGroup}>
                        <label className={styles.label}>{t("auth.emailLabel")}</label>
                        <input type="email" {...register("email")} className={styles.input}/>
                        {errors.email && <p className={styles.error}>{errors.email.message}</p>}
                    </div>

                    <button type="submit" disabled={isSubmitting || loading} className={styles.submitBtn}>
                        {isSubmitting || loading ? t("auth.forgotPasswordSending") : t("auth.forgotPasswordSubmit")}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
